import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { AccountService } from '../../../../../services/account.service';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { CommonfilterService } from 'src/app/services/commonfilter.service';
import { ConfirmDiscountComponent } from '../confirm-discount/confirm-discount.component';
import { ConfirmRemoveDiscountComponent } from '../confirm-removediscount/confirm-removediscount.component';


@Component({
  selector: 'app-invoice-dialog',
  templateUrl: './invoice-dialog.component.html',
  styleUrls: ['./invoice-dialog.component.css']
})
export class InvoiceDialogComponent implements OnInit {
  invoice: any;
  credit_debit: any;
  adjustments: any;
  isChecked = false;
  showDiscount = false;
  public discountForm: UntypedFormGroup;
  credt_debtJson: any;
  credt_debtDetls: any;
  hideCreditDebt = true;
  licenseDiscountType: any[] = [];
  configData: any;
  licenseDiscounts: any;
  bothdiscounts: any = [];
  api_error: any;
  api_success: string;
  licenseDetails: any = {};
  show = false;
  discountDetailsTxt;
  addonDetails: any;
  btndisabled = false;
  gstNumber: any;
  showPreviousDue = false;
  previousStatements: any = {
    addonDetailsArray: [],
    licensePkgDetailsArray: [],
    creditDeditArray: []
  };
  latestInvoiceDiscount: any = [];
  hideLicense = true;
  licenseSubscriptionDiscount: any = [];
  adhocDiscount: any = [];
  previousInvoiceRefNumber: any = [];
  margeinvoice: any = [];
  discounts: any = [];
  discount_detail;
  discount_value;
  mergedref;
  statemntview;
  desAmount;
  hideClose = true;
  constructor(
    private dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data: number,
    private dialog: MatDialog,
    private accountService: AccountService, private commonService: CommonfilterService,
    private formbuilder: UntypedFormBuilder, private discount_dialog: MatDialog) {
    this.createForm();
    this.commonService.getConfigData()
      .subscribe(res => {
        this.configData = res;
        this.licenseDiscountType = this.configData.licenseDiscTypes;
      });
  }
  formErrors = {
    'name': '',
    'calculationType': '',
    'description': '',
    'discountValue': ''

  };
  ValidationMessages = {
    'name': {
      'required': 'DiscountName is required',

    },
    'calculationType': {
      'required': 'DiscountType is required'
    },
    'description': {
      'required': 'Description is required'
    },
    'discountValue': {
      'required': 'DiscountValue is required'
    }
  }

  ngOnInit() {
     this.getInvoiceDetails();
    this.accountService.getGSTNumber()
      .subscribe(res => {
        this.gstNumber = res;
      });
  }
  createForm() {
    this.discountForm = this.formbuilder.group({
      name: ['', Validators.required],
      discountValue: ['', Validators.required],
      calculationType: ['Fixed'],
      description: ['', Validators.required]

    });
  }
  checkPreviousStatements(mergedStatements) {
    if (mergedStatements.statements.length !== 0) {
      mergedStatements.statements.forEach(object => {
        if (object.addonDetails) {
          object.addonDetails.forEach(addon => {
            if (object.discountTotal) {
              addon['discountTotal'] = object.discountTotal;
            }
            this.previousStatements.addonDetailsArray.push(addon);
          });
        }
        if (object.discount) {
          const licenseDiscounts = JSON.parse(object.discount);
          licenseDiscounts.discount.forEach(discountObj => {
            this.discounts.push(discountObj);
          });
        }
        if (object.licensePkgDetails) {
          if (object.discountTotal) {
            object.licensePkgDetails['discountTotal'] = object.discountTotal;
          }
          this.previousStatements.licensePkgDetailsArray.push(object.licensePkgDetails);
        }
        if (object.creditDebitJson) {
          const credit_debit = JSON.parse(object.creditDebitJson);
          credit_debit.creditDebitDetails.forEach(creditDebtObj => {
          this.previousStatements.creditDeditArray.push(creditDebtObj);
          });
        }
        if (object.mergedStatements !== null) {
          this.checkPreviousStatements(object.mergedStatements);
        }

      });
      console.log('creditDEbitArray........' + this.previousStatements.creditDebitArray);
      console.log('creditDEbitArray........' + JSON.stringify(this.previousStatements.creditDebitArray));

    }

  }
  getInvoiceDetails() {
    this.adhocDiscount = [];
    this.bothdiscounts = [];
    this.discounts = [];
    this.latestInvoiceDiscount = [];
    this.licenseSubscriptionDiscount = [];

    this.accountService.getInvoice(this.data)
    .subscribe(res => {
      this.invoice = res;
      console.log('invoice......' + JSON.stringify(this.invoice));
      if (!this.invoice.createdBySystem) {
        this.desAmount = this.invoice.amount - this.invoice.balance;
      }
      if (this.invoice.licensePkgDetails) {
        this.hideLicense = false;
        this.licenseDetails = this.invoice.licensePkgDetails;
      }
      if (this.invoice.addonDetails) {
        this.addonDetails = this.invoice.addonDetails;
      }
      if (this.invoice.creditDebitJson) {
        this.hideCreditDebt = false;
        this.credt_debtJson = JSON.parse(this.invoice.creditDebitJson);
        this.credt_debtDetls = this.credt_debtJson.creditDebitDetails;
        this.credit_debit = JSON.parse(this.invoice.creditDebitJson);
        this.adjustments = this.credit_debit.creditDebitDetails;
      }
      if (this.invoice.discount) {
        // this.licenseDiscounts = JSON.parse(this.invoice.discount);
        this.licenseDiscounts = this.invoice.discount;
        this.licenseDiscounts.discount.forEach(discountObj => {

          if (discountObj.discountType === 'Predefined') {
           this.licenseSubscriptionDiscount.push(discountObj);
          } else if (discountObj.discountType === 'OnDemand') {
           this.adhocDiscount.push(discountObj);
          }
          this.bothdiscounts.push(discountObj);
         // this.latestInvoiceDiscount.push(discountObj);
          // this.discounts.push(discountObj);
        });
      }
      // if (this.invoice.mergedStatements) {
      //   this.checkPreviousStatements(this.invoice.mergedStatements);
      //   console.log('old statements.........' + JSON.stringify(this.previousStatements));
      //   console.log('discounts.....' + JSON.stringify(this.discounts));
      // }
         if (this.invoice.mergedStatements) {
           this.getPreviousInvoiceRefNumber(this.invoice.mergedStatements);
        // this.checkPreviousStatements(this.invoice.mergedStatements);
       // console.log('old statements.........' + JSON.stringify(this.previousStatements));
        // console.log('discounts.....' + JSON.stringify(this.discounts));
       }

    });
  }
  getPreviousInvoiceRefNumber(mergedStatements) {
    if (mergedStatements.statements.length !== 0) {
      mergedStatements.statements.forEach(object => {
        this.previousInvoiceRefNumber = object.invoiceRefNumber;
        console.log(this.previousInvoiceRefNumber.toString());
        return ;
      });
      }
  }
  onDiscountApply() {
    this.btndisabled = true;
    this.api_error = '';
    this.api_success = '';
    const account_uuid = this.invoice.ynwUuid;
    const data = {
      'uuid': account_uuid,
      'discount': this.discountForm.value
    };
    this.accountService.applyinvoiceDiscount(data)
      .subscribe(res => {
        this.discount_detail = res;
        console.log(this.discount_detail);
        // this.discount_detail.forEach(saleschannel_filter => {
        //  this.discount_value = saleschannel_filter;
        //  console.log(this.discount_value);
        // });
        this.api_success = 'Discount applied successfully';
        this.btndisabled = false;
        setTimeout(() => {
        this.api_success = '';
        this.isChecked = false;
        this.getInvoiceDetails();
        this.show = false;
        this.showDiscount = false;
        this.discountForm.reset();
          }, 1000);
      },
        (error) => {
          this.btndisabled = false;

          this.api_error = error.error;
        });
        console.log(data);
  }
  onRemovedDiscount() {
    this.accountService.removeOndemandinvoiceDiscount(this.invoice.ynwUuid)
    .subscribe(res => {
      this.api_success = 'Discount removed successfully';
      this.btndisabled = false;
      setTimeout(() => {
        this.api_success = '';
        this.isChecked = false;
        this.getInvoiceDetails();
        this.show = false;
        this.showDiscount = false;
        this.discountForm.reset();
          }, 1000);
    },
      (error) => {
        this.btndisabled = false;

        this.api_error = error.error;
      });
  }
  // applydiscount() {
  //   const dialogRef = this.dialog.open(StatementConfirmComponent, {
  //     width: '700px',
  //   });

  //   dialogRef.afterClosed().subscribe(result => {
  //     this.onDiscountApply();
  //   });

  // }
  // showAppliedDiscounts() {
  //   const discountDialogRef = this.discount_dialog.open(DiscountDetailInfoComponent, {
  //      width: '900px',
  //      data : this.discounts
  //   });
  //   discountDialogRef.afterClosed().subscribe(result => {
  //    console.log('discount dialog closed');
  //   });
  // }
  toggleDiscountDetails() {
    this.show = !this.show;
    if (this.show) {
      this.discountDetailsTxt = 'Hide discount details';
    } else {
      this.discountDetailsTxt = 'Show discount details';
    }

  }

  // togglePreviousDue() {
  //   this.showPreviousDue = !this.showPreviousDue;
  // }
margeStatement(invoiceRefNumber) {
  this.showPreviousDue = !this.showPreviousDue;
  this.accountService.mergeStmt(invoiceRefNumber)
  .subscribe(res => {
       this.margeinvoice = res;
    console.log(this.margeinvoice);
    // this.margeinvoice = res;
    // this.margeinvoice.forEach(merge_refno => {
    //  this.mergedref = merge_refno;
    //  console.log(this.mergedref);
    // });
 
    this.api_success = '';
    setTimeout(() => {
      this.api_success = '';
      this.discountForm.reset();
        }, 1000);
  },
    (error) => {
      this.btndisabled = false;
      this.api_error = error.error;
    });
}
  checkValue(event: any) {
    if (event) {
      this.showDiscount = true;
    } else {
      this.showDiscount = false;

    }
  }
  confirmDiscount() {
    const account_uuid = this.invoice.ynwUuid;
    const dialogRef = this.dialog.open(ConfirmDiscountComponent, {
      width: '600px',
      // tslint:disable-next-line:max-line-length
    });
    dialogRef.afterClosed().subscribe(result => {
      this.onDiscountApply();
    });
  }
  onRemoveDiscount() {
    const account_uuid = this.invoice.ynwUuid;
    const dialogRef = this.dialog.open(ConfirmRemoveDiscountComponent, {
      width: '600px',
      // tslint:disable-next-line:max-line-length
    });
    dialogRef.afterClosed().subscribe(result => {
      this.onRemovedDiscount();
    });
  }
  printMe() {
    this.hideClose = false;
    setTimeout(() => {
      window.print();
    }, 1000);
  
       
  }
  onPrint() {
    const printContent = document.getElementById("printMe");
    var htmlToPrint = '' +
      '<style type="text/css">' +
      'table th, table td {' +
      'border:1px solid #000;' +
      'padding:0.5em;' +
      '}' +
      'table {' +
      'border-collapse: collapse;' +
      '}' +
      '.text-center {' +
      'text-align: center;' +
      '}' +
      '</style>';
    htmlToPrint += printContent.outerHTML;
    const WindowPrt = window.open('', '', 'left=0,top=0,width=900,height=900,toolbar=0,scrollbars=0,status=0');
    WindowPrt.document.write(htmlToPrint);
    WindowPrt.document.close();
    WindowPrt.focus();
    WindowPrt.print();
    // WindowPrt.close();
  }
}
